export default __webpack_public_path__ + "static/media/Exterior-(19).25934456.jpg";